let inMemoryToken: string | null = null;
const TOKEN_KEY = 'auth_jwt';

export function setAuthToken(token: string): void {
  inMemoryToken = token;
  try {
    sessionStorage.setItem(TOKEN_KEY, token);
  } catch (error) {
    console.error('Error setting auth token:', error);
  }
}

export function getAuthToken(): string | null {
  if (inMemoryToken) return inMemoryToken;
  try {
    const fromSession = sessionStorage.getItem(TOKEN_KEY);
    if (fromSession) {
      inMemoryToken = fromSession;
      return fromSession;
    }
  } catch (error) {
    console.error('Error getting auth token:', error);
  }

  // Local development only. This used to be a static import of a gitignored
  // src/constants/jwt.json, which webpack resolves unconditionally and so broke
  // every clean build (including Docker/Fly) regardless of the flag below.
  // Anything in a REACT_APP_* variable is inlined into the public bundle, so
  // leave REACT_APP_TEST_JWT unset in any deployed environment.
  if (
    process.env.REACT_APP_USE_TEST_JWT === 'true' &&
    process.env.REACT_APP_TEST_JWT
  ) {
    return process.env.REACT_APP_TEST_JWT;
  }

  return null;
}

export function clearAuthToken(): void {
  inMemoryToken = null;
  try {
    sessionStorage.removeItem(TOKEN_KEY);
  } catch (error) {
    console.error('Error clearing auth token:', error);
  }
}

export function getAuthHeaders(): Record<string, string> {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function getUserEmailFromToken(): string | null {
  const token = getAuthToken();
  if (!token) return null;
  
  try {
    // JWT structure: header.payload.signature
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload));
    return decoded.username || decoded.email || decoded.sub || null;
  } catch (error) {
    console.error('Error decoding JWT:', error);
    return null;
  }
}
